import { GET_DONATION_INFO_LOADING, DONATION_DATA_SUCCESS, DONATION_DATA_ERROR } from "../actions/actionDonation";
import { apiDonation } from 'api';
import { put, takeEvery } from 'redux-saga/effects';

async function fetchAsync(func, param) {
    const response = await func(param);

    if (response.ok && response.status == 200) {
        return await response.json();
    }
    else if (response.status == 204) {
        return "nocontent";
    }
    if (response.status == 400) {
        let error = await response.json();
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get donations, response status: " + response.status + "\"}]}")
    }
}

function* fetchDontionsData(action) {
    try {
        const data = yield fetchAsync(apiDonation, action.payload)
        yield put({ type: DONATION_DATA_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: DONATION_DATA_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

export const sagaDonation = [
    takeEvery(GET_DONATION_INFO_LOADING, fetchDontionsData)
];
